import React from 'react'

import { Box, FontWeight, Text } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { InstrumentedErrorComponent, ERROR_COMPONENT_MODES } from '@library/browser-errors'
import { BROWSER_ERROR_KEYS } from '@library/observability/browser'

import { Alert, AlertSeverity } from 'routes/Checkout/Components/Alert/Alert'
import { getGeneralErrors } from 'routes/Checkout/checkoutSelectors'

const ERROR_MESSAGE_COPY = {
  header: 'Something went wrong',
  message: 'Please try again later',
}

export const PaypalTokenErrorNotification = () => {
  const checkoutErrors = useSelector(getGeneralErrors)

  const filteredError = checkoutErrors.findEntry(
    (value, key) => value === true && key === 'PAYPAL_TOKEN_ERROR_AT_CHECKOUT',
  )

  const paypalTokenError = !!filteredError

  return paypalTokenError ? (
    <InstrumentedErrorComponent
      mode={ERROR_COMPONENT_MODES.ON_RENDER}
      errorKey={BROWSER_ERROR_KEYS.PAYPAL_ERROR}
      message={ERROR_MESSAGE_COPY.message}
      cause="cannot fetch braintree token"
    >
      <Box style={{ marginBottom: '1.75rem' }}>
        <Alert severity={AlertSeverity.Error}>
          <Text fontWeight={FontWeight.Bold} size={2}>
            {ERROR_MESSAGE_COPY.header}
          </Text>
          <Box>
            <Text size={2}>{ERROR_MESSAGE_COPY.message}</Text>
          </Box>
        </Alert>
      </Box>
    </InstrumentedErrorComponent>
  ) : null
}
